<template>
	<v-col cols="12" md="4" class="px-2 treatment-card mb-5">
		<v-card height="84px" :to="custom ? { name: 'custom-pre-made-treatments', params: { ctid: treatment.id, custom: true } } : treatment.to">
			<v-card-title>
        <v-icon v-if="custom" color="primary" class="mr-2">mdi-clipboard-text</v-icon>
				<v-icon v-else-if="treatment.code === 'acu'" color="primary" class="mr-2">$vuetify.icons.acuIcon</v-icon>
				<v-icon v-else-if="treatment.code === 'cmm'" color="primary" class="mr-2">$vuetify.icons.tcmIcon</v-icon>
				<v-icon v-else color="primary" class="mr-2">{{treatment.icon}}</v-icon>
				<span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'">{{treatment.name}}</span>
        <v-spacer></v-spacer>
        <template v-if="custom && $store.getters.hasRole('manager')">
          <v-btn icon @click.stop.prevent="editUsers" :disabled="loading">
            <v-icon color="primary">mdi-account-group</v-icon>
          </v-btn>
          <v-btn icon @click.stop.prevent="edit" :disabled="loading">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
        </template>
        <!-- <v-btn small v-if="custom" icon>
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn> -->
				<!-- <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn class="float-right" icon @click="showInfo = true" v-on="on">
              <v-icon color="primary">info_outline</v-icon>
            </v-btn>
          </template>
          <span>Info</span>
				</v-tooltip>-->
				<!-- <v-dialog v-model="showInfo" width="1000">
          <v-card>
            <v-card-title class="title primary--text mb-2 secondary">Treatment Info</v-card-title>
            <v-card-text>
              <h2>{{treatment.name}}</h2>
              {{treatment.info}}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="showInfo = false">Close</v-btn>
            </v-card-actions>
          </v-card>
				</v-dialog>-->
			</v-card-title>
			<v-card-actions></v-card-actions>
		</v-card>
	</v-col>
</template>

<script>
export default {
	name: "TreatmentCard",
	props: ["treatment", "custom", "loading"],
	data: () => ({
		showInfo: false
  }),
  methods: {
    editUsers() {
      this.$emit('edit-users');
    },
    edit() {
      this.$emit('edit');
    }
  }
};
</script>